import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
import heroBg from '../assets/hero-bg.jpg';
import { personalData } from '../data/content';

export default function Hero() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src={heroBg} 
          alt="Nature Abstract Background" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40 mix-blend-multiply" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-emerald-400 font-medium tracking-wider uppercase text-sm md:text-base mb-4">
            {personalData.title}
          </h2>
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-6 leading-tight">
            {personalData.name}
          </h1>
          <p className="text-lg md:text-2xl text-gray-200 max-w-3xl mx-auto leading-relaxed font-light">
            {personalData.tagline}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
          className="mt-12 flex justify-center gap-4"
        >
          <a 
            href="#about" 
            className="px-8 py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-full font-medium transition-all transform hover:scale-105 shadow-lg hover:shadow-emerald-500/25"
          >
            Learn More
          </a>
          <a 
            href="#contact" 
            className="px-8 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium transition-all"
          >
            Get in Touch
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white/70"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
        >
          <ArrowDown size={32} />
        </motion.div>
      </motion.div>
    </section>
  );
}
